// extracted by mini-css-extract-plugin
export default {"upload":"UploadFile_upload__SwVou"};